import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { RxButtonModule } from '../button/button.module';

@Component({
  selector: 'rx-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  standalone: true,
  imports: [CommonModule, RxButtonModule, ModalContentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  @Input() title: string;
  @Input() body: string;
  @Input() cancelLabel: string;
  @Input() confirmLabel: string;
  @Input() showCloseButton = false;
  @Input() headerCentered = true;
  @Input() bodyCentered = true;
  @Input() buttonsCentered = true;

  constructor(public activeModal: NgbActiveModal) {}
}
